<template>
  <div :class="menuClass + ' custom-container'">
    <div v-if="loader" class="loading-layout">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else class="home">
      <div v-if="$vuetify.breakpoint.smAndDown && changeProductDialog">
        <ChangeProduct
          :bus="bus"
          v-on:ChangeProductClose="closeChangeProductDialog"
        ></ChangeProduct>
      </div>
      <div v-else>
        <div class="top">
          <div class="select-wrap">
            <v-select
              :items="contracts"
              v-model="selectedContract"
              item-value="id"
              hide-details
              label=""
            >
              <template slot="selection" slot-scope="{ item }">
                {{ item.street }} {{ item.house }}, {{ item.city }}
              </template>
              <template slot="item" slot-scope="{ item }">
                {{ item.street }} {{ item.house }}, {{ item.city }} -
                {{ item.ap }}
              </template>
            </v-select>
          </div>
        </div>

        <div class="home-content">
          <v-card>
            <div class="home-content-block">
              <div class="home-block charge-image">
                <img :src="houseImage" alt="house" />
              </div>

              <div class="home-block contract-change">
                <div class="product-label font-size-1">Strømavtale</div>
                <div class="current-contracts-list">
                  <div class="primary-block">
                    <v-btn
                      color="primary"
                      outlined
                      width="100%"
                      rounded
                      class="common-btn primary-color"
                      v-on:click="
                        changeProduct(
                          selectedContract,
                          selectedContract.primaryProduct,
                          true
                        )
                      "
                    >
                      <v-icon color="primary">mdi-lightning-bolt</v-icon>
                      <div class="primary--text">
                        {{ selectedContract.primaryProduct.ProductName }}
                      </div>
                    </v-btn>

                    <v-btn
                      outlined
                      width="100%"
                      v-for="(item, key) in selectedContract.secondaryProducts"
                      class="current-contract secondary-contract cursor-pointer"
                      :key="key"
                      v-on:click="changeProduct(selectedContract, item, false)"
                    >
                      <v-icon color="primary">mdi-power-plug</v-icon>
                      <div class="primary--text">{{ item.ProductName }}</div>
                    </v-btn>

                    <section v-if="visible">
                      <div
                        v-if="
                          !selectedContract.secondaryProducts ||
                          selectedContract.secondaryProducts.length <= 0
                        "
                        class="current-contract secondary-contract cursor-pointer"
                        v-on:click="
                          changeProduct(selectedContract, false, false)
                        "
                      >
                        <v-icon>mdi-plus</v-icon>
                        <div>Legg til produkt</div>
                      </div>
                    </section>
                  </div>
                  <p v-if="upcommingPrimary.StartDate" class="upcomming-label">
                    {{
                      $moment(upcommingPrimary.StartDate).format('DD') +
                      ' ' +
                      getNorwayMonth(
                        new Date(upcommingPrimary.StartDate).getMonth()
                      ) +
                      ' ' +
                      $moment(upcommingPrimary.StartDate).format('YYYY')
                    }}
                    endres avtalen til {{ upcommingPrimary.ProductName }}
                  </p>
                </div>
              </div>
            </div>

            <div class="home-content-block">
              <div class="home-block">
                <div class="header">
                  <div>
                    <div class="label font-size-12">
                      Forbruk i {{ formatedMonth }}
                    </div>
                    <div class="sublabel d-flex align-center">
                      <div>
                        <v-icon class="font-size-11" style="color: #bbbbbb"
                          >mdi-clock-time-four</v-icon
                        >
                      </div>
                      <div class="ml-1">
                        {{
                          $moment(now).daysInMonth() - $moment(now).format('DD')
                        }}
                        dager igjen av perioden
                      </div>
                    </div>
                  </div>
                </div>

                <div class="consumption-chart">
                  <div>
                    <div class="value">
                      {{ totalConsumption }} <span>kWh</span>
                    </div>
                    <div
                      v-if="isProfiledMeasured()"
                      class="force-align-left sublabel"
                    >
                      Forbruket er beregnet
                    </div>
                  </div>
                  <div class="chart">
                    <VueApexCharts
                      type="bar"
                      height="100"
                      width="150"
                      :options="chartOptions1"
                      :series="series1"
                    ></VueApexCharts>
                  </div>
                </div>

                <div
                  class="consumption-chart"
                  :style="
                    !$vuetify.breakpoint.smAndDown ? '' : 'margin-top:-30px;'
                  "
                >
                  <div>
                    <div class="value">
                      {{ totalConsumptionCalculation }} <span>kr</span>
                    </div>
                    <div v-if="vatIncluded" class="force-align-left vat">
                      Inkl mva
                    </div>
                    <div v-else class="force-align-left vat">Eks mva</div>
                  </div>
                  <div class="chart">
                    <VueApexCharts
                      type="bar"
                      height="100"
                      width="150"
                      :options="chartOptions2"
                      :series="series2"
                    ></VueApexCharts>
                  </div>
                </div>

                <div v-if="!isNaN(compare)" class="compare">
                  <div class="value">
                    <span>{{ Math.abs(compare.toFixed(1)) }}%</span>
                    <v-icon v-if="compare && compare > 0" color="green"
                      >mdi-arrow-top-right</v-icon
                    >
                    <v-icon v-if="compare && compare < 0" color="red"
                      >mdi-arrow-bottom-right</v-icon
                    >

                    <span class="label"
                      >Endring i forbruk fra
                      {{
                        getNorwayMonth(
                          new Date(
                            $moment(now).subtract(1, 'months').toISOString()
                          ).getMonth()
                        )
                      }}</span
                    >
                    <div class="sublabel">Beløpet inkluderer ikke nettleie</div>
                  </div>
                </div>
              </div>

              <div class="home-block contract-change-mobile">
                <div class="product-label">Strømavtale</div>
                <div class="current-contracts-list">
                  <div class="primary-block">
                    <v-btn
                      color="primary"
                      outlined
                      width="100%"
                      rounded
                      class="common-btn primary-color"
                      v-if="selectedContract.primaryProduct"
                      v-on:click="
                        changeProduct(
                          selectedContract,
                          selectedContract.primaryProduct,
                          true
                        )
                      "
                    >
                      <v-icon color="primary">mdi-lightning-bolt</v-icon>
                      <div class="primary--text">
                        {{ selectedContract.primaryProduct.ProductName }}
                      </div>
                    </v-btn>

                    <div
                      v-for="(item, key) in selectedContract.secondaryProducts"
                      class="current-contract secondary-contract cursor-pointer"
                      :key="key"
                      v-on:click="changeProduct(selectedContract, item, false)"
                    >
                      <v-icon>mdi-power-plug</v-icon>
                      <div class="label">{{ item.ProductName }}</div>
                    </div>
                    <section v-if="visible">
                      <div
                        v-if="
                          !selectedContract.secondaryProducts ||
                          selectedContract.secondaryProducts.length <= 0
                        "
                        class="current-contract secondary-contract cursor-pointer"
                        v-on:click="
                          changeProduct(selectedContract, false, false)
                        "
                      >
                        <v-icon>mdi-plus</v-icon>
                        <div>Legg til produkt</div>
                      </div>
                    </section>
                  </div>
                  <p v-if="upcommingPrimary.StartDate" class="upcomming-label">
                    {{
                      $moment(upcommingPrimary.StartDate).format('DD') +
                      ' ' +
                      getNorwayMonth(
                        new Date(upcommingPrimary.StartDate).getMonth()
                      ) +
                      ' ' +
                      $moment(upcommingPrimary.StartDate).format('YYYY')
                    }}
                    endres avtalen til {{ upcommingPrimary.ProductName }}
                  </p>
                </div>
              </div>

              <div class="home-block">
                <div>
                  <div
                    :class="
                      !$vuetify.breakpoint.smAndDown ? 'header' : 'header mt-8'
                    "
                  >
                    <div>
                      <div class="label font-size-12">Pris per kWh</div>
                      <div class="sublabel d-flex align-center mb-3">
                        <div>
                          <v-icon class="font-size-11" style="color: #bbbbbb"
                            >mdi-clock-time-four</v-icon
                          >
                        </div>
                        <div class="ml-1">Akkurat nå</div>
                      </div>
                    </div>
                  </div>

                  <div class="consumption-chart" v-if="isPrice">
                    <div>
                      <div>
                        <div class="value">
                          {{ currentPrice }} <span>øre</span>
                        </div>
                        <div v-if="vatIncluded" class="force-align-left vat">
                          Inkl mva
                        </div>
                        <div v-else class="force-align-left vat">Eks mva</div>
                      </div>
                    </div>

                    <div class="chart">
                      <VueApexCharts
                        type="area"
                        height="130"
                        width="200"
                        :options="chartOptions3"
                        :series="series3"
                      ></VueApexCharts>
                    </div>
                  </div>

                  <div class="compare">
                    <div class="value">
                      <span>{{ Math.abs(comparePrice.toFixed(1)) }}%</span>
                      <v-icon
                        v-if="comparePrice && comparePrice > 0"
                        color="green"
                        >mdi-arrow-top-right</v-icon
                      >
                      <v-icon
                        v-if="comparePrice && comparePrice < 0"
                        color="red"
                        >mdi-arrow-bottom-right</v-icon
                      >

                      <span class="label">Prisendring fra i går</span>
                    </div>

                    <div class="sublabel">
                      Prisen inkluderer påslag og avgifter
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </div>
        <v-dialog
          v-model="changeProductDialog"
          width="700"
          style="overflow-x: hidden !important"
          class="hide-overflow-x"
          content-class="hide-overflow-x"
        >
          <ChangeProduct
            :bus="bus"
            v-on:ChangeProductClose="closeChangeProductDialog"
          ></ChangeProduct>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import ChangeProduct from '../../components/ChangeProduct/ChangeProduct';
import HouseImage from '../../assets/house.png';

import VueApexCharts from 'vue-apexcharts';
import {
  consumption,
  consumptionCalculation,
  getPrices,
  accountingPoints,
  products,
} from '../../api/common';
import {
  getNorwayMonth,
  convertDateStr,
  convertDateStrEncoded,
} from '../../utils/date';
import './Home.scss';
import moment from 'moment';
import Vue from 'vue';

const getTenant = `*[_type == "config"]{
				colors
			}`;

export default {
  name: 'Home',

  components: { VueApexCharts, ChangeProduct },

  data() {
    return {
      visible: false,
      bus: new Vue(),
      vatIncluded: false,
      vat: 25,
      now: convertDateStr(new Date().toISOString()),
      loader: false,
      changeProductDialog: false,
      allPrimaryProducts: [],
      allSecondaryProducts: [],
      checkbox: false,
      daysPeriod: 0,
      upcommingPrimary: '',
      upcommingSecondary: '',
      primaryProduct: '',
      accountingSelection: [],
      totalConsumption: 0,
      totalConsumptionCalculation: 0,
      lastMonthTotalConsumption: 0,
      lastMonthTotalConsumptionCalculation: 0,
      lastMonth: '',
      consumptionLastDay: '',
      lastMonthCalculation: '',
      consumptionLastDayCalculation: '',
      primaryProductEdit: '',
      menuClass: '',
      companyColor: '',
      compare: 0,
      period: 'Daily',
      selectedProduct: '',
      series1: [],
      series2: [],
      series3: [],
      pravicy: false,
      selectedPrimaryProduct: '',
      selectedSecondaryProduct: '',
      productTochange: '',
      isPrice: false,
      isConsumptionCalculation: false,
      consumptionForPrice: [],
      isConsPrice: false,
      currentPrice: 0,
      lastDayTotalPrice: 0,
      currentPriceCalculation: 0,
      totalPrice: 0,
      comparePrice: 0,
      chartDates: [],
      chartDates2: [],
      chartDates3: [],
      chartOptions1: {
        chart: {
          type: 'bar',
          height: 50,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
            startingShape: 'rounded',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: false,
        },

        yaxis: {
          show: false,
        },

        xaxis: {
          labels: {
            show: false,
          },
        },

        grid: {
          show: false,
          borderColor: '#ffffff',
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: false,
            },
          },
        },

        legend: {
          show: false,
        },

        fill: {
          opacity: 0.8,
        },

        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex }) => {
            return this.chartDates2.length
              ? "<div class='chart-tip'><b>" +
                  this.chartDates2[dataPointIndex] +
                  "</b>  <span class='value'>Forbruk: " +
                  series[seriesIndex][dataPointIndex] +
                  'kWh</span></div>'
              : "<div class='chart-tip'><span class='value'> Forbruk: " +
                  series[seriesIndex][dataPointIndex] +
                  'kWh</span></div>';
          },
        },
      },
      chartOptions2: {
        chart: {
          type: 'bar',
          height: 50,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
            startingShape: 'rounded',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: false,
        },

        yaxis: {
          show: false,
        },

        xaxis: {
          labels: {
            show: false,
          },
        },

        grid: {
          show: false,
          borderColor: '#ffffff',
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: false,
            },
          },
        },

        legend: {
          show: false,
        },

        fill: {
          opacity: 0.8,
        },

        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex }) => {
            return this.chartDates3.length
              ? "<div class='chart-tip'><b>" +
                  this.chartDates3[dataPointIndex] +
                  "</b>  <span class='value'>Forbruk : " +
                  series[seriesIndex][dataPointIndex] +
                  'NOK</span></div>'
              : "<div class='chart-tip'><span class='value'> Forbruk: " +
                  series[seriesIndex][dataPointIndex] +
                  'NOK</span></div>';
          },
        },
      },
      chartOptions3: {
        chart: {
          type: 'area',
          height: 100,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 2,
          curve: 'smooth',
        },
        dataLabels: {
          enabled: false,
        },

        yaxis: {
          show: false,
        },

        xaxis: {
          labels: {
            show: false,
          },
        },

        grid: {
          show: false,
          borderColor: '#ffffff',
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: false,
            },
          },
        },

        legend: {
          show: false,
        },

        fill: {
          opacity: 0.8,
        },

        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex }) => {
            return this.chartDates.length
              ? "<div class='chart-tip'><b>" +
                  this.chartDates[dataPointIndex] +
                  "</b>  <span class='value'>Pris per kWh: " +
                  series[seriesIndex][dataPointIndex] +
                  'øre</span></div>'
              : "<div class='chart-tip'><span class='value'> Pris per kWh: " +
                  series[seriesIndex][dataPointIndex] +
                  'øre</span></div>';
          },
          fixed: {
            enabled: true,
            position: 'topLeft',
            offsetY: -20,
          },
        },
      },
    };
  },

  beforeMount() {
    this.loader = true;
  },

  async created() {
    this.fetchTenant();
  },

  async mounted() {
    let now = convertDateStr(new Date().toISOString());
    this.houseImage = HouseImage;

    if (this.selectedContract) {
      this.loader = true;
      await this.getConsumptionByMetering(
        this.selectedContract.AccountingPointIdentification
      );
      await this.getConsumptionCalculationByMetering(
        this.selectedContract.AccountingPointIdentification
      );
      this.loader = false;
    }

    this.formatedMonth = getNorwayMonth(moment(now).month());
    this.formatedPrevMonth = getNorwayMonth(
      parseInt(moment(now).subtract(1, 'months').format('MM')) - 1
    );

    try {
      let tmp = (await products()).data.products;
      this.allPrimaryProducts = tmp.filter(
        (item) => item.primaryProduct === true
      );
      this.allSecondaryProducts = tmp.filter(
        (item) => item.primaryProduct === false
      );

      const activeSecondaryProducts = this.allSecondaryProducts.filter(
        (item) => {
          return item.tags.includes('minside');
        }
      );
      this.visible = activeSecondaryProducts.length === 0 ? false : true;
    } catch (e) {
      console.log(e);
    }
  },

  computed: {
    primaryProducts() {
      let products = this.$store.getters['getPrimaryProducts'];

      return products;
    },

    secondaryProducts() {
      let products = this.$store.getters['getSecondaryProducts'];

      return products;
    },

    currentContract() {
      return this.$store.getters['getCurrentContract'];
    },

    guid() {
      return this.$store.getters['getGuid'];
    },

    user() {
      return this.$store.getters['getUser'];
    },

    contracts() {
      return this.$store.getters['getContracts'];
    },

    selectedContract: {
      get() {
        return this.$store.getters['getSelectedContract'];
      },

      set(value) {
        let contract = this.contracts.find((item) => {
          return item.id === value;
        });

        if (contract) {
          this.$store.commit('setSelectedContract', contract);
        }
      },
    },
  },

  watch: {
    async selectedContract(contract) {
      this.loader = true;
      await this.getConsumptionByMetering(
        contract.AccountingPointIdentification
      );
      await this.getConsumptionCalculationByMetering(
        contract.AccountingPointIdentification
      );
      this.loader = false;

      if (contract.UpcomingProductChange) {
        let upcommingPrimary = contract.UpcomingProductChange.Products.find(
          (item) => {
            return item.PrimaryProduct === true;
          }
        );

        if (upcommingPrimary) {
          this.upcommingPrimary = upcommingPrimary;
        }

        let upcommingSecondary = contract.UpcomingProductChange.Products.find(
          (item) => {
            return item.PrimaryProduct === false;
          }
        );

        if (upcommingSecondary) {
          this.upcommingSecondary = upcommingSecondary;
        }
      } else {
        this.upcommingPrimary = '';
        this.upcommingSecondary = '';
      }
    },
  },

  methods: {
    async fetchTenant() {
      await this.$sanity.fetch(getTenant).then(
        (tenant) => {
          this.$vuetify.theme.themes.light.primary = tenant[0].colors.primary;
          this.$vuetify.theme.themes.light.secondary =
            tenant[0].colors.secondary;

          this.chartOptions1.fill.colors = [
            this.$vuetify.theme.themes.light.primary,
          ];
          this.chartOptions2.fill.colors = [
            this.$vuetify.theme.themes.light.primary,
          ];
          this.chartOptions3.fill.colors = [
            this.$vuetify.theme.themes.light.primary,
          ];
          this.chartOptions3.stroke.colors = [
            this.$vuetify.theme.themes.light.primary,
          ];
        },
        (error) => {
          this.error = error;
        }
      );
    },
    isProfiledMeasured() {
      if (
        this.selectedContract &&
        this.selectedContract.Characteristics &&
        this.selectedContract.Characteristics.SettlementMethodType == 'E01'
      ) {
        return true;
      } else {
        return false;
      }
    },

    async getPrices(date, current) {
      let now = convertDateStr(new Date().toISOString());

      let params = {
        ap: this.selectedContract.AccountingPointIdentification,
        customer: this.guid,
        date: date,
      };

      try {
        let res = await getPrices(params);

        if (current) {
          let data = [
              {
                name: 'Price',
                data: [],
              },
            ],
            total = 0;

          let currentHour = parseInt(this.$moment().format('HH'));
          let currentHourPrice;

          let tmpPriceSequence = [];
          for (let i = 1; i <= 24; i++) {
            let hourData = res.data.consumptionPriceSequenceAggregated.filter(
              (item) => item.sequence == i
            );
            if (hourData && hourData.length > 0) {
              tmpPriceSequence.push(Object.assign({}, hourData[0]));
            } else {
              tmpPriceSequence.push({ sequence: i, price: 0 });
            }
          }

          tmpPriceSequence.forEach((item) => {
            data[0].data.push(
              this.applyTax(parseFloat(item.price) * 100).toFixed(2)
            );
            total += parseFloat(item.price);

            let time = '00:00',
              timeNext = '01:00',
              date =
                this.$moment(res.data.date).format('DD') +
                ' ' +
                getNorwayMonth(this.$moment(now).month());

            if (item.sequence < 11) {
              time = '0' + (item.sequence - 1) + ':00';
              timeNext = '0' + item.sequence + ':00';
            } else {
              time = +(item.sequence - 1) + ':00';
              timeNext = +item.sequence + ':00';
            }

            this.chartDates.push(date + ' kl ' + time + ' - ' + timeNext);

            if (item.sequence - 1 == currentHour) {
              currentHourPrice = this.applyTax(
                parseFloat(item.price) * 100
              ).toFixed(2);
            }
          });

          this.totalPrice = this.applyTax(total).toFixed(2);
          this.series3 = data;
          this.currentPrice =
            currentHourPrice || currentHourPrice === 0
              ? currentHourPrice
              : this.applyTax(
                  parseFloat(res.data.consumptionPrice) * 100
                ).toFixed(2);
          this.isPrice = true;
        } else {
          let total = 0;

          res.data.consumptionPriceSequenceAggregated.forEach((item) => {
            total += parseFloat(item.price);
          });

          total = this.applyTax(total);

          if (this.totalPrice) {
            this.comparePrice =
              (((total.toFixed(2) - this.totalPrice) * 100) /
                total.toFixed(2)) *
              -1;
          } else {
            this.comparePrice = 0;
          }
        }

        return res;
      } catch (err) {
        console.log(err.message);
        this.isPrice = false;
        throw err;
      }
    },

    getMonth(month) {
      return getNorwayMonth(month);
    },

    getNorwayMonth(month) {
      return getNorwayMonth(month);
    },

    getAddressTitle(address) {
      let firstPart = (
        (address.StreetName || '') +
        ' ' +
        (address.BuildingNumber || '')
      ).trim();
      let secondPart = (
        (address.PostalCode || '') +
        ' ' +
        (address.City || '')
      ).trim();
      let decoratedAddress =
        firstPart + (firstPart && secondPart ? ',' : '') + secondPart;

      return decoratedAddress;
    },

    closeChangeProductDialog(data) {
      this.changeProductDialog = false;
      console.log(data);
      if (data && data.refresh) {
        setTimeout(function () {
          location.reload();
        }, 500);
      }
    },

    changeProduct(selectedContract, selectedProduct, selectedProductPrimary) {
      this.changeProductDialog = true;

      let self = this;
      setTimeout(function () {
        self.bus.$emit('ProductChanged', {
          page: selectedProductPrimary ? 0 : 1,
          selectedContract: selectedContract,
          selectedProduct: selectedProduct,
          selectedProductPrimary: selectedProductPrimary,
          primaryProductsReference: self.allPrimaryProducts,
          secondaryProductsReference: self.allSecondaryProducts,
        });
      }, 250);
    },

    setPrimaryProduct(key) {
      this.primaryProductEdit = key;
    },

    async getComsumption(params, current) {
      let now = convertDateStr(new Date().toISOString());
      let res = await consumption(params);

      let totalConsumption = 0,
        newData = [
          {
            name: 'Consumption',
            data: [],
          },
        ];

      if (this.consumptionLastDay) {
        if (res.data.consumptions.length) {
          this.consumptionLastDay =
            res.data.consumptions[res.data.consumptions.length - 1].endTime;
        }

        res.data.consumptions.forEach((item) => {
          totalConsumption += item.consumption;
        });
      } else {
        res.data.consumptions.forEach((item) => {
          totalConsumption += item.consumption;
        });
      }

      if (current) {
        let days = {};

        for (let i = 7; i >= 1; i--) {
          let date = this.$moment(now).subtract(i, 'days');
          let prevDate = this.$moment(date).subtract(1, 'days');
          let day = parseInt(date.format('DD'));
          let prevDay = parseInt(prevDate.format('DD'));

          this.chartDates2.push(day + ' ' + this.getNorwayMonth(date.month()));

          (res.data.consumptions || []).forEach((consumption) => {
            let startDay = parseInt(consumption.startTime.substring(8, 10));
            let startTime = parseInt(consumption.startTime.substring(14, 16));

            let endDay = parseInt(consumption.endTime.substring(8, 10));
            let endTime = parseInt(consumption.endTime.substring(14, 16));

            if (
              startDay == prevDay &&
              startTime == 0 &&
              endDay == day &&
              endTime == 59
            ) {
              if (!days[day]) {
                days[day] = true;
                newData[0].data.push((consumption.consumption || 0).toFixed(2));
                this.consumptionForPrice.push({
                  date: consumption.endTime,
                  value: consumption.consumption,
                });
              }
            }
          });

          if (!days[day]) {
            days[day] = true;
            newData[0].data.push((0).toFixed(2));
            this.consumptionForPrice.push({
              date: date.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
              value: 0,
            });
          }
        }

        this.series1 = newData;
      }
      return totalConsumption.toFixed(2);
    },

    async getConsumptionCalculationByMetering(id) {
      let now = convertDateStr(new Date().toISOString());

      let daysTillNow = parseInt(
        this.$moment(now).subtract(1, 'days').format('DD')
      );

      let meteringPoint = id,
        startDate = convertDateStrEncoded(
          this.$moment(now).startOf('month').format('YYYY-MM-DDTHH:mm:ss')
        ),
        endDate = convertDateStrEncoded(
          this.$moment(now)
            .startOf('month')
            .set('date', daysTillNow)
            .format('YYYY-MM-DDTHH:mm:ss')
        ),
        params =
          'meteringpoint=' +
          meteringPoint +
          '&firstDay=' +
          startDate +
          '&lastDay=' +
          endDate +
          '&agg=d&forceFetchData=0&customer=' +
          this.guid;
      try {
        let resMonth = await this.getConsumptionCalculation(params, true);
        this.totalConsumptionCalculation = resMonth;
      } catch (err) {
        console.log(err.message);
      }
    },

    async getConsumptionCalculation(params, current) {
      let now = convertDateStr(new Date().toISOString());
      let res = await consumptionCalculation(params, current);

      let totalCalculation = 0,
        newData = [
          {
            name: 'Consumption',
            data: [],
          },
        ];

      if (
        current &&
        res.data.acknowledge &&
        res.data.acknowledge.responseText == 'OK'
      ) {
        (res.data.calculations || []).forEach((calculation) => {
          totalCalculation += calculation.amount;
        });

        let days = {};

        for (let i = 7; i >= 1; i--) {
          let date = this.$moment(now).subtract(i, 'days');
          let prevDate = this.$moment(date).subtract(1, 'days');
          let day = parseInt(date.format('DD'));
          let prevDay = parseInt(prevDate.format('DD'));

          this.chartDates3.push(day + ' ' + this.getNorwayMonth(date.month()));

          (res.data.calculations || []).forEach((calculation) => {
            let startDay = parseInt(calculation.start.substring(8, 10));
            let startTime = parseInt(calculation.start.substring(14, 16));

            let endDay = parseInt(calculation.end.substring(8, 10));
            let endTime = parseInt(calculation.end.substring(14, 16));

            if (
              startDay == prevDay &&
              startTime == 0 &&
              endDay == day &&
              endTime == 59
            ) {
              if (!days[day]) {
                days[day] = true;
                newData[0].data.push(
                  this.applyTax(calculation.amount || 0).toFixed(2)
                );
              }
            }
          });

          if (!days[day]) {
            days[day] = true;
            newData[0].data.push((0).toFixed(2));
          }
        }

        this.series2 = newData;
      }

      return this.applyTax(totalCalculation || 0).toFixed(2);
      // return Math.round(this.applyTax(totalCalculation || 0));
    },

    async getConsumptionByMetering(id) {
      let now = convertDateStr(new Date().toISOString());

      let daysTillNow = parseInt(
        this.$moment(now).subtract(1, 'days').format('DD')
      );
      let daysLastMonth = parseInt(
        this.$moment(now).subtract(1, 'months').daysInMonth()
      );

      let meteringPoint = id,
        startDate = this.$moment(now).startOf('month').format('YYYY-MM-DD'),
        endDate = this.$moment(now)
          .startOf('month')
          .set('date', daysTillNow)
          .format('YYYY-MM-DD'),
        params =
          'meteringpoint=' +
          meteringPoint +
          '&firstDay=' +
          startDate +
          '&lastDay=' +
          endDate +
          '&agg=d',
        lastMonthStart = this.$moment(now)
          .subtract(1, 'months')
          .startOf('month')
          .format('YYYY-MM-DD'),
        lastMonthEnd = this.$moment(now)
          .subtract(1, 'months')
          .startOf('month')
          .set(
            'date',
            daysTillNow > daysLastMonth ? daysLastMonth : daysTillNow
          )
          .format('YYYY-MM-DD'),
        lastMonthParams =
          'meteringpoint=' +
          meteringPoint +
          '&firstDay=' +
          lastMonthStart +
          '&lastDay=' +
          lastMonthEnd +
          '&agg=d';

      try {
        let resMonth = await this.getComsumption(params, true);
        let resLastMonth = await this.getComsumption(lastMonthParams);

        this.totalConsumption = resMonth;

        if (this.totalConsumption) {
          this.compare =
            (((resLastMonth - this.totalConsumption) * 100) / resLastMonth) *
            -1;
        } else {
          this.compare = 0;
        }

        this.lastMonth = this.$moment(lastMonthEnd).format('MMMM');
        this.consumptionLastDay = '';

        this.comparePrice = 0;
        let resPrices = await this.getPrices(
          convertDateStrEncoded(new Date().toISOString()),
          true
        );
        if (resPrices)
          await this.getPrices(
            convertDateStrEncoded(
              this.$moment(now)
                .subtract(1, 'days')
                .format('YYYY-MM-DDTHH:mm:ss')
            )
          );
      } catch (err) {
        console.log(err.message);
      }
    },

    getContracts() {
      return new Promise((resolve, reject) => {
        accountingPoints()
          .then((res) => {
            if (res.data) {
              let filteredContracts = res.data.AccountingPoints.filter(
                (item) => item.Status === 'Active' || item.Status === 'Pending'
              );

              this.$store.commit('setContracts', filteredContracts);
            }
          })
          .catch((error) => {
            console.log(error);

            reject(error);
          });
      });
    },

    applyTax(value) {
      let user = this.user;
      this.vatIncluded = false;

      if (user && user.Identification && user.Identification.length == 9) {
        return value;
      } else {
        if (
          this.selectedContract &&
          this.selectedContract.TaxationProfile &&
          this.selectedContract.TaxationProfile.VATCode &&
          this.selectedContract.TaxationProfile.VATCode.toLowerCase().trim() ==
            's'
        ) {
          this.vatIncluded = true;
          return value + (value * this.vat) / 100;
        }
      }

      return value;
    },
  },
};
</script>
